export const chiangMaiKlookAttractions = {
  'night-safari-tour':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1091950&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F73503-chiangmai-night-safari-tour-shared-transfer%2F%3Fspm%3DSearchResult.SearchResult_LIST%26clickId%3D606d78b09f',
  'fah-lanna-spa':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1165179&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F711-fah-lanna-spa-chiangmai%2F',
  'cheeva-spa':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1165181&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F78957-cheeva-spa-experience-chiangmai%2F',
};
